export interface IStorage {
    setData(key: string, data: string | any): void;

    getData(key: string): string | null;

    removeData(key: string): void;

    clear(): void;

    hasKey(key: string): boolean;

    keys(): Array<string>

    values(): Array<string>

    getAll(): Array<object>
}

// Local storage
class LocalStorage implements IStorage {
    setData(key: string, data: any | string) {
        if (typeof data === 'string') {
            localStorage.setItem(key, data);
        } else {
            let json = JSON.stringify(data);
            localStorage.setItem(key, json);
        }
    }

    getData(key: string): string | null {
        return localStorage.getItem(key);
    }

    removeData(key: string) {
        localStorage.removeItem(key);
    }

    clear() {
        localStorage.clear();
    }

    keys(): Array<string> {
        let keys: Array<string> = [];
        Object.keys(localStorage).forEach((key) => {
            keys.push(key);
        });

        return keys;
    }

    values(): Array<string> {
        let values: Array<string> = [];
        Object.keys(localStorage).forEach((key) => {
            let value = localStorage.getItem(key);
            if (value != null) {
                values.push(value);
            }
        });

        return values;
    }

    hasKey(key: string): boolean {
        return this.keys().includes(key);
    }

    getAll(): Array<object> {
        let all: Array<object> = [];
        Object.keys(localStorage).forEach((key) => {
            let value = localStorage.getItem(key);
            let obj = {
                key: key,
                value: value
            };
            all.push(obj);
        });

        return all;
    }
}

// Session storage
class SessionStorage implements IStorage {
    setData(key: string, data: any | string) {
        if (typeof data === 'string') {
            sessionStorage.setItem(key, data);
        } else {
            let json = JSON.stringify(data);
            sessionStorage.setItem(key, json);
        }
    }

    getData(key: string): string | null {
        return sessionStorage.getItem(key);
    }

    removeData(key: string) {
        sessionStorage.removeItem(key);
    }

    clear() {
        sessionStorage.clear();
    }

    keys(): Array<string> {
        let keys: Array<string> = [];
        Object.keys(sessionStorage).forEach((key) => {
            keys.push(key);
        });

        return keys;
    }

    values(): Array<string> {
        let values: Array<string> = [];
        Object.keys(sessionStorage).forEach((key) => {
            let value = sessionStorage.getItem(key);
            if (value != null) {
                values.push(value);
            }
        });

        return values;
    }

    hasKey(key: string): boolean {
        return this.keys().includes(key);
    }

    getAll(): Array<object> {
        let all: Array<object> = [];
        Object.keys(sessionStorage).forEach((key) => {
            let value = sessionStorage.getItem(key);
            let obj = {
                key: key,
                value: value
            };
            all.push(obj);
        });

        return all;
    }
}


export const localStorageInstance: IStorage = new LocalStorage();
export const sessionStorageInstance: IStorage = new SessionStorage();
